const apiMap = {
  localhost: 'https://ucenter.yunkeduntest.com',
  'eeop.yunkeduntest.com': 'https://ucenter.yunkeduntest.com',
  'eeop.yunkedun.com': 'https://ucenter.yunkedun.com',
  'eeop.qinglukeji.cn': 'https://ucenter.yunkedun.com',
};


const baseUrl = apiMap[window.location.hostname]; // 总校区api地址，分校区api根据校区接口返回的domain

export default baseUrl;



// WEBPACK FOOTER //
// ./src/utils/api.js